export default "/static/dashboard/build/app/img/v2/43224e97cf748c00dae1e61e02e7b15a.png";